export default "__VITE_ASSET__CrAYknbN__"